<!-- AI: This is the template for the new LightEntrepreneurClientEditDialogComponent -->
<h2 mat-dialog-title>Edit Light Entrepreneur: {{ client.name }}</h2>

<mat-dialog-content>
  <form [formGroup]="clientForm" id="le-client-edit-form" (ngSubmit)="save()" *ngIf="countries$ | async as countries" novalidate>
    <div class.="form-grid">
      <mat-form-field>
        <input matInput placeholder="Name" formControlName="name" />
      </mat-form-field>

      <mat-form-field>
        <input matInput placeholder="Personal ID" formControlName="personal_id" />
      </mat-form-field>

      <mat-form-field>
        <input matInput placeholder="Invoicing Service Company Business ID" formControlName="invoicing_service_company_business_id" />
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="Country" formControlName="country">
          <mat-option *ngFor="let option of countries.all()" [value]="option.code">
            {{option.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <div class="toggle-checkbox">
        <mat-checkbox class="full-width" formControlName="has_credit_limit" labelPosition="after">Credit Limit</mat-checkbox>
      </div>

      <mat-form-field *ngIf="clientForm.value.has_credit_limit" formGroupName="credit_limit">
        <ng-container formGroupName="limit">
          <input matInput placeholder="Credit Limit" formControlName="amount" type="number" />
        </ng-container>
      </mat-form-field>

    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-button color="primary" type="submit" form="le-client-edit-form" [disabled]="!clientForm.valid">Save</button>
</mat-dialog-actions>
